import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic'
const Navbar = dynamic(() => import('../components/Layouts/Navbar', { ssr: false }))
const Breadcrumb = dynamic(() => import('../components/Layouts/Breadcrumb', { ssr: false }))
const LandingIntroduction = dynamic(() => import('../components/Consulting/Listing/LandingIntroduction', { ssr: false }))
const ConsultingServices = dynamic(() => import('../components/Consulting/Listing/ConsultingServices', { ssr: false }))
const ImageCardSection = dynamic(() => import('../components/Consulting/Listing/ImageCardSection', { ssr: false }))
const ProvenImpact = dynamic(() => import('../components/Consulting/Listing/ProvenImpact', { ssr: false }))
const CaseStudy = dynamic(() => import('../components/Consulting/Listing/CaseStudy', { ssr: false }))
const Newsletter = dynamic(() => import('../components/Consulting/Listing/Newsletter', { ssr: false }))
const RelatedArticles = dynamic(() => import('../components/Consulting/Listing/RelatedArticles', { ssr: false }))
const HaveAnyPlans = dynamic(() => import('../components/Consulting/Listing/HaveAnyPlans', { ssr: false }))
const Footer = dynamic(() => import('../components/Layouts/Footer', { ssr: false }))
import HeroBanner from '../components/Common/HeroBanner';
import Head from 'next/head'
import axios from 'axios';
import DButton from '../components/elements/DButton';

const Consulting = ({ metaDetails, slug }) => {

  const [metaData, setMetaData] = useState(null);
  const [metaSlug, setmetaSlug] = useState(null);

  useEffect(() => {
    try {
      const slug = (window.location.pathname).split('/').pop();
      const complete_url = window.location.href;
      setmetaSlug(complete_url)
      axios.get(process.env.API_URL + '/meta/' + slug).then((res) => {
        if (res.data?.code == 200) {
          setMetaData(res.data)
        } 
      }).catch((error) => {

      })
    } catch (err) {

    }
  }, [])

  return (
    <>
      <Head>
        <title>{(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "}</title>
        <meta name="description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
        <meta name="keywords" content={(metaDetails != undefined) ? metaDetails.meta_keywords : (metaData) ? metaData?.meta_keywords : "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."} />
        <meta property="og:title" content={(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "} />
        <meta property="og:description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
        <meta name="twitter:title" content={(metaDetails != undefined) ? metaDetails.meta_title : (metaData) ? metaData?.meta_title : " Healthcare Market Research Reports & Consulting Firm | DelveInsight "} />
        <meta name="twitter:description" content={(metaDetails != undefined) ? metaDetails.meta_description : (metaData) ? metaData?.meta_description : "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies."} />
        <meta property="og:url" content={(slug) ? slug : metaSlug} />
      </Head>
      <Navbar />
      <HeroBanner background={process.env.IMG_CDN + "img/consulting/jpg/consulting-banner.png"}
        title={<>Unique challenges, Innovative Healthcare Consulting Solutions</>}
        description={<>Help strengthen your strategic decision-making through our insightful outcomes generated via well- established research methodologies and healthcare consulting services. <br/> Develop business cognizance and stay abreast of industry dynamics, through our judicious biopharmaceutical and life science consulting solutions and advisory</>}
        buttonOnBanner={<>
          <div className="flex sm:grid-cols-4 grid-cols-1">
            <DButton title="Request For Proposal" redirect="/request-for-proposal" customClass='' />
          </div>
        </>}
      />
      <Breadcrumb />
      <LandingIntroduction />
      <div style={{ backgroundColor: '#012a5e' }} >
        <ConsultingServices title="Our Healthcare Consulting Services" />
      </div>
      <ImageCardSection priority={true} title="Sectors" />
      <ProvenImpact title="Proven Impact" />
      <CaseStudy title="Healthcare Strategy Consulting Case Studies" />
      <Newsletter title="Healthcare Consulting Related Whitepapers" />
      <RelatedArticles title="Healthcare Consulting Related Articles" />
      <HaveAnyPlans title="Have Any Project Plans?" />
      <Footer />
    </>
  )
}

export default Consulting;

export async function getServerSideProps({ req, res, resolvedUrl }) {

  let slug = resolvedUrl;
  let full_slug = process.env.APP_URL + resolvedUrl;
  if (slug.includes('/_next/')) {
    // checking if it making request json file then skip to fetch Meta Data
    return {
      props: {
        metaDetails: {
          meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
          meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
          meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
        },
        slug: full_slug
      }
    };
  } else {
    // Remove the trailing slash, if any
    const cleanedSlug = slug.replace(/\/$/, '');
    try {
      const response = await axios.get(process.env.API_URL + '/meta/' + cleanedSlug);
      const metaDetails = response.data;

      if (metaDetails == undefined || metaDetails == '' || metaDetails == null || metaDetails?.code === 404) {
        return {
          props: {
            metaDetails: {
              meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
              meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
              meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
            },
            slug: full_slug
          }
        }
      } else {
        return {
          props: {
            metaDetails: metaDetails,
            slug: full_slug
          },
        };

      }
    } catch (error) {
      // console.error('Error fetching API data:', error);

      return {
        props: {
          metaDetails: {
            meta_title: "Healthcare Market Research Reports & Consulting Firm | DelveInsight",
            meta_description: "DelveInsight is a pioneer in Healthcare Market Research Reports & Consulting Services. We advise Pharma leaders on making strategic decisions across all therapy areas & geographies.",
            meta_keywords: "pharmaceutical business consulting, market research company, pharma consulting, biotech consulting, pharma market research, pharma market insights, biotech consulting,  pharma consulting service, pharma leading, market trends."
          },
          slug: full_slug
        },
      };
    }
  }
}